import { useContext } from "react";

import { RoutingContext } from "../context";

/**
 * This should be used whenever links are rendered in the app.
 *
 * Paths should be prefixed with the given path prefix
 * (unless explicitly excluded)
 */
export function useRoutePathPrefix(): string {
  const { pathPrefix } = useContext(RoutingContext);
  return pathPrefix ?? "";
}
